import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00c8145a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clue" }, null, -1))
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kuang" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div1" }, "Ready go，"),
  /*#__PURE__*/_createElementVNode("div", { class: "div2" }, "深入追踪，进行确诊")
], -1))
const _hoisted_4 = { class: "fdj" }
const _hoisted_5 = {
  style: {"width":"4rem","margin":"0 auto"},
  class: "home"
}
const _hoisted_6 = { class: "ip" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_question = _resolveComponent("question")!
  const _component_correctTwo = _resolveComponent("correctTwo")!
  const _component_correctThree = _resolveComponent("correctThree")!
  const _component_correctReason = _resolveComponent("correctReason")!
  const _component_diag = _resolveComponent("diag")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_image, {
        width: "2.1333rem",
        height: ".6667rem",
        src: require('../assets/logo.png')
      }, null, 8, ["src"])
    ]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_van_image, {
        width: "7rem",
        height: "7rem",
        src: require('../assets/ip.png')
      }, null, 8, ["src"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_van_image, {
          onClick: $options.showPopup,
          width: "2.5733rem",
          height: "2.5733rem",
          src: require('../assets/jixu.png')
        }, null, 8, ["onClick", "src"]),
        _createVNode(_component_van_image, {
          class: "finger",
          width: "1.28rem",
          height: "1.28rem",
          src: require('../assets/dong.gif')
        }, null, 8, ["src"])
      ]),
      _createVNode(_component_van_popup, {
        show: $data.show,
        "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (($data.show) = $event))
      }, {
        default: _withCtx(() => [
          ($data.flag == 'question')
            ? (_openBlock(), _createBlock(_component_question, {
                key: 0,
                onOnChanged: $options.updateChanged,
                postaimqus: $data.postaimqus
              }, null, 8, ["onOnChanged", "postaimqus"]))
            : _createCommentVNode("", true),
          ($data.flag == 'correctTwo')
            ? (_openBlock(), _createBlock(_component_correctTwo, {
                key: 1,
                onOnChanged: $options.correctTwo,
                postaimqus: $data.postaimqus,
                correct: $data.correct,
                aimQus: $data.postaimqus
              }, null, 8, ["onOnChanged", "postaimqus", "correct", "aimQus"]))
            : _createCommentVNode("", true),
          ($data.flag == 'correctThree')
            ? (_openBlock(), _createBlock(_component_correctThree, {
                key: 2,
                onOnChanged: $options.updateCorrectThree,
                postaimqus: $data.postaimqus,
                correct: $data.correct,
                aimQus: $data.postaimqus
              }, null, 8, ["onOnChanged", "postaimqus", "correct", "aimQus"]))
            : _createCommentVNode("", true),
          ($data.flag == 'correctReason')
            ? (_openBlock(), _createBlock(_component_correctReason, {
                key: 3,
                onOnChanged: $options.correctReason,
                postaimqus: $data.postaimqus,
                correct: $data.correct,
                aimQus: $data.postaimqus
              }, null, 8, ["onOnChanged", "postaimqus", "correct", "aimQus"]))
            : _createCommentVNode("", true),
          ($data.flag == 'diag')
            ? (_openBlock(), _createBlock(_component_diag, {
                key: 4,
                onOnChanged: $options.diag,
                postaimqus: $data.postaimqus,
                correct: $data.correct,
                aimQus: $data.postaimqus
              }, null, 8, ["onOnChanged", "postaimqus", "correct", "aimQus"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["show"])
    ])
  ], 64))
}